import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { detailCourseSelect, getCourseList } from 'redux-api/slices/courseSlice';
import { PATHS } from 'common/constants';
import { courseLink, withExtraCourses } from 'common/extraCourses';
import HomeButton from './HomeButton';
import HomeSectionHead from './HomeSectionHead';
import classes from './HomeCourses.module.scss';


const HomeCourses = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { courseList } = useSelector(detailCourseSelect);

  // В макете у каждого курса своя картинка — берём курсы, у которых она есть.
  const courses = withExtraCourses(courseList.courses?.filter((course) => !!course.inactive_preview_image) ?? []);

  useEffect(() => {
    dispatch(getCourseList());
    return () => null;
  }, [ dispatch ]);

  if (!courses.length) return null;

  return (
    <section className={classes.courses}>
      <div className={classes.container}>
        <HomeSectionHead
          title={t('OurCourses')}
          action={<HomeButton to={PATHS.allcourses}>{t('AllCourses')}</HomeButton>}
        />

        <div className={classes.grid}>
          {courses.map((course, i) => (
            <button
              type="button"
              className={classes.card}
              key={course.slug ?? i}
              onClick={() => navigate(courseLink(course))}
              data-aos="fade-up"
              data-aos-delay={(i % 4) * 80}
            >
              <span className={classes.imageBox}>
                <img
                  src={course.inactive_preview_image}
                  alt={course.inactive_preview_image_alt || course.title}
                  draggable={false}
                  loading="lazy"
                />
              </span>
              <span className={classes.title}>{course.title}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeCourses;
